import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionsContext';
import { Lock, Shield, ArrowLeft, Sparkles } from 'lucide-react';

export const ProtectedRoute = ({ 
  permission, 
  permissions,
  requireAll = false,
  children 
}) => {
  const accessToken = localStorage.getItem("accessToken");
  const { hasPermission, hasAnyPermission, hasAllPermissions, isLoading, userRole } = usePermissions();

  console.log('🔐 ProtectedRoute check:', {
    permission,
    permissions,
    requireAll,
    isLoading,
    userRole,
    hasToken: !!accessToken
  });

  // لو مافيش token، ارجع للـ login
  if (!accessToken) {
    console.log('❌ No access token - redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // لو بيحمّل الصلاحيات
  if (isLoading) {
    console.log('⏳ Loading permissions...');
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <div className="text-center">
          <div className="text-6xl mb-6 animate-bounce">⏳</div>
          <div className="w-16 h-16 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">جاري التحميل... ✨</p>
        </div>
      </div>
    );
  }

  // تحقق من الصلاحيات
  let hasAccess = true;

  if (permission) {
    hasAccess = hasPermission(permission);
    console.log(`🔍 Single permission check: ${permission} =`, hasAccess);
  } else if (permissions && requireAll) {
    hasAccess = hasAllPermissions(permissions);
    console.log(`🔍 All permissions check:`, permissions, '=', hasAccess);
  } else if (permissions) {
    hasAccess = hasAnyPermission(permissions);
    console.log(`🔍 Any permission check:`, permissions, '=', hasAccess);
  }

  // لو مافيش صلاحية - الصفحة المبهجة الجديدة! 🎉
  if (!hasAccess) {
    console.log('❌ Access denied - showing forbidden page');
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-4">
        <div className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 rounded-3xl border-2 border-yellow-500/30 p-12 max-w-2xl w-full text-center shadow-2xl backdrop-blur-sm animate-fade-in">
          
          {/* ✨ Emoji كبير ومبهج مع animation */}
          <div className="relative inline-block mb-8">
            <div className="text-9xl animate-bounce">
              🔒
            </div>
            {/* أيقونات متحركة حول الـ Emoji */}
            <div className="absolute -top-4 -right-4 text-4xl animate-spin-slow">✨</div>
            <div className="absolute -bottom-4 -left-4 text-4xl animate-spin-slow delay-300">💫</div>
            <div className="absolute -top-4 -left-4 text-4xl animate-pulse">⭐</div>
            <div className="absolute -bottom-4 -right-4 text-4xl animate-pulse delay-200">🌟</div>
          </div>
          
          {/* عنوان رئيسي */}
          <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 mb-4 animate-gradient">
            عفواً! 🌟
          </h2>
          
          {/* الرسالة الأساسية */}
          <p className="text-xl text-gray-300 mb-6 leading-relaxed">
            هذه الصفحة تحتاج إلى صلاحيات خاصة للوصول إليها
          </p>
          
          {/* أيقونات توضيحية متحركة */}
          {/* <div className="flex justify-center gap-6 mb-8">
            <div className="text-5xl animate-bounce delay-0">🎯</div>
            <div className="text-5xl animate-bounce delay-100">✨</div>
            <div className="text-5xl animate-bounce delay-200">💫</div>
          </div> */}
          
          {/* رسالة تحفيزية */}
          <div className="bg-gradient-to-r from-yellow-500/10 via-yellow-400/10 to-yellow-500/10 rounded-xl border border-yellow-500/30 p-6 mb-8 hover:border-yellow-500/50 transition-all duration-300">
            <div className="flex items-center justify-center gap-3 mb-3">
              <Shield className="w-7 h-7 text-yellow-400 animate-pulse" />
              <Sparkles className="w-6 h-6 text-yellow-300 animate-spin-slow" />
            </div>
            <p className="text-lg text-yellow-300 font-medium">
              يمكنك التواصل مع المسؤول لطلب الصلاحيات 
            </p>
          </div>
          
          {/* أزرار التنقل */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.history.back()}
              className="group flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-yellow-500/50"
            >
              <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
              <span>العودة للخلف</span>
            </button>
            
            {/* <button
              onClick={() => window.location.href = '/'}
              className="px-8 py-4 bg-gray-700/50 hover:bg-gray-700 text-yellow-400 font-bold rounded-xl transition-all duration-300 transform hover:scale-105 border border-yellow-500/30 hover:border-yellow-500/50"
            >
              🏠 الصفحة الرئيسية
            </button> */}
          </div>
          
          {/* رسالة إضافية صغيرة */}
          {/* <p className="text-sm text-gray-500 mt-8">
            إذا كنت تعتقد أن هذا خطأ، يرجى التواصل مع فريق الدعم 🤝
          </p> */}
        </div>
      </div>
    );
  }

  console.log('✅ Access granted - rendering component');
  return <>{children}</>;
};